import WangWang from "@/components/WangWang";
import OrderDTO from "@/dto/order/OrderDTO";
import React from "react";
import WithPopoverTip from "../WithPopoverTip";
import ShopType from "@/enum/ShopType";
import { observer } from "mobx-react-lite";

interface AlibabaBuyerUsernameProps {
    order: OrderDTO;

    onSearch?: () => void;
}

const AlibabaBuyerUsername: React.FC<AlibabaBuyerUsernameProps> = observer(function (props) {
    const { order, onSearch } = props;

    const buyerUsername = order.buyerUsername;
    const buyerNickname = order.buyerNickname;
    const bizDomain = "cbu";

    if (buyerNickname && buyerUsername) {
        return (
            <WithPopoverTip
                onSearch={onSearch}
                otherTip={<div className="text-gray text-small">买家ID: {buyerUsername}</div>}
            >
                <WangWang
                    nick={buyerNickname}
                    bizDomain={bizDomain}
                    decryptedNick={ShopType.ALIBABA}
                    shopId={order.shopId}
                    openId={buyerUsername}
                />
            </WithPopoverTip>
        );
    }

    return (
        <WithPopoverTip onSearch={onSearch}>
            <WangWang nick={buyerUsername} bizDomain={bizDomain} />
        </WithPopoverTip>
    );
});

export default AlibabaBuyerUsername;
